export default "__VITE_ASSET__BzbQrqH5__"